.base {
  flex: 1;
  display: flex;
  align-items: center;
}

.welcomeWrapper .base {
  flex: unset !important;
}

.base > div {
  display: flex;
  flex-direction: column;
  padding: 0;
  box-shadow: none;
  height: max-content;
}

.welcomeWrapper.desktopWrapper {
  gap: 32px;
}

.welcomeWrapper.desktopWrapper > div {
  width: 448px;
  margin: 0 auto;
}

.desktopWrapper .base {
  margin: 0 auto;
}

.desktopWrapper .base {
  width: 448px;
}

.filterAvailability section {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.filterMultiCheck section {
  justify-content: center;
}

.headerVisible {
  opacity: 1;
  pointer-events: auto;
}

.headerHidden {
  opacity: 0;
  pointer-events: none;
}
